import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from './FallbackPage';
import { ASSET_NAME } from './LandingPage.duck';
import { getBlobFiles, getFeaturedListings } from './LandingPage.duck';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const LandingPageComponent = props => {
  const { pageAssetsData, inProgress, error, getBlobFilesResult, currentUser, searchSuggestions } = props;

  return (
    <>
      <PageBuilder
        pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
        inProgress={inProgress}
        error={error}
        isLandingPage={true}
        getBlobFilesResult={getBlobFilesResult}
        searchSuggestions={searchSuggestions}
        fallbackPage={<FallbackPage error={error} />}
      />
    </>
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { getBlobFilesResult } = state.LandingPage;
  const { currentUser } = state.user;
  const { suggestions: searchSuggestions } = state.customAISearch || {};
  return { pageAssetsData, inProgress, error, getBlobFilesResult, currentUser, searchSuggestions };
};

const mapDispatchToProps = dispatch => ({
  onGetBlobFiles: () => dispatch(getBlobFiles()),
  onGetFeaturedListings: params => dispatch(getFeaturedListings(params)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps,mapDispatchToProps))(LandingPageComponent);

export default LandingPage;


